<template>
  <nav
    class="pagination-wrapper"
    :class="wrapperCssClasses"
    role="navigation"
    aria-label="Search Results Pagination Navigation"
  >
    <ul class="pagination">
      <!-- Previous Link -->
      <template v-if="onFirstPage">
        <li class="page-item disabled" style="cursor: not-allowed">
          <span class="page-link"><i class="fal fa-chevron-left"></i></span>
        </li>
      </template>
      <template v-else>
        <li class="page-item">
          <a
            class="page-link"
            href="#"
            rel="prev"
            @click.prevent="$emit('go-to-previous-page')"
            aria-label="Go to previous page"
          >
            <i class="fal fa-chevron-left"></i>
            <template v-if="previousText">
              <span class="d-inline-block ml-1">{{ previousText }}</span>
            </template>
          </a>
        </li>
      </template>

      <template>
        <!-- Print an <li> for every page -->
        <!-- Hide pages that are outside the range of the current page -->
        <li
          class="page-item"
          v-for="page in numPages"
          :key="page"
          :class="{
            active: page == currentPage,
            'd-none':
              (!showAllPages && page > 3 && page < midRangePages.low) ||
              (page > midRangePages.high && page < numPages - 2),
            disabled:
              !showAllPages &&
              ((page == 3 && currentPage >= 5) ||
                (currentPage < numPages - 8 && page == numPages - 2))
          }"
        >
          <!-- Show ellipsis on the third and third-to-last pages -->
          <a
            class="page-link"
            href="#"
            @click.prevent="$emit('go-to-page', page)"
            :aria-current="page == currentPage"
            :aria-label="
              `${
                page == currentPage
                  ? `Current Page, Page ${page}`
                  : `Go to Page ${page}`
              }`
            "
          >
            <template
              v-if="
                (!showAllPages && page == 3 && currentPage > 6) ||
                  (currentPage < numPages - 8 && page == numPages - 2)
              "
            >
              ...
            </template>
            <template v-else>
              {{ page }}
            </template>
          </a>
        </li>
      </template>

      <!-- Next Link -->
      <template v-if="onLastPage">
        <li class="page-item disabled" style="cursor: not-allowed">
          <span class="page-link"><i class="fal fa-chevron-right"></i></span>
        </li>
      </template>
      <template v-else>
        <li class="page-item">
          <a
            class="page-link"
            href="#"
            rel="next"
            @click.prevent="$emit('go-to-next-page')"
            aria-label="Go to next page"
          >
            <template v-if="nextText">
              <span class="d-inline-block mr-1">{{ nextText }}</span>
            </template>
            <i class="fal fa-chevron-right"></i>
          </a>
        </li>
      </template>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    pagesToShow: {
      type: Number,
      default: 4
    },
    currentPage: {
      type: Number,
      default: 1
    },
    numPages: {
      type: Number
    },
    previousText: {
      type: String,
      default: 'Previous'
    },
    nextText: {
      type: String,
      default: 'Next'
    },
    wrapperCssClasses: {
      type: String
    }
  },
  computed: {
    onFirstPage() {
      return this.currentPage == 1;
    },
    onLastPage() {
      return this.currentPage == this.numPages;
    },
    showAllPages() {
      return this.numPages <= this.pagesToShow;
    },
    midRangePages() {
      if (this.showAllPages) return false;
      let low = this.currentPage - 3 <= 0 ? 0 : this.currentPage - 3;
      let high = low + 6 > this.numPages ? this.numPages : low + 6;
      if (this.currentPage < 7) {
        low = 0;
        high = low + 7;
      }
      if (high >= this.numPages) {
        high = this.numPages;
        low = high - 8;
      }
      return {
        low,
        high
      };
    }
  }
};
</script>

<style>

</style>
